import { Deserializable } from '../../../lib';

export class EditableAppFlagsDto implements Deserializable {
  public HasPermissionsToModifyApp: boolean;
  public HasPermissionsToModifyFactFind: boolean;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
